module.exports = __webpack_public_path__ + "static/media/calender.321308bc.svg";